module.exports = __webpack_public_path__ + "cw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cw.svg
// module id = 507
// module chunks = 0